import type { Nullable, StringNumber } from "web/types/Utils";

const fractionDigits = 2;
const pattern = /(-?\d+)(\d{3})/;
const ZERO_STR = (0).toFixed(fractionDigits).replace(".", ",");

const parse = (number: StringNumber) => {
  let numberString = number.toString();
  while (pattern.test(numberString)) {
    numberString = numberString.replace(pattern, "$1 $2");
  }
  return numberString;
};

// Format number 123456789.12345 to 123 456 789,12
const formatNumber = (number: Nullable<StringNumber>) => {
  if (!number) {
    return ZERO_STR;
  }

  if (number === "-") {
    return "-";
  }

  const num = typeof number === "string" ? +number.replace(",", ".") : number;

  return typeof num === "number" && !Number.isNaN(num)
    ? parse(num.toFixed(fractionDigits).replace(".", ","))
    : num.toString().replace(/./g, ",");
};

export default formatNumber;
